import React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    DateInput,
    SelectInput,
    ReferenceInput,
    FileInput,
    FileField
} from 'react-admin';
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const AdminCompaniesHouseFilingHistoryEdit = () => {

    return (
        <Edit>
            <SimpleForm>
                <DateInput name="date" source="date" validate={[required()]} fullWidth />
                <TextInput name="type" source="type" fullWidth />
                <TextInput name="description" source="description" fullWidth />
                <ReferenceInput
                    label="Companies House For"
                    source="companiesHouse"
                    reference="companies_house"
                >
                    <SelectInput optionText="companyName"/>
                </ReferenceInput>
                <FileInput source="pdf" accept={{ 'application/pdf': ['.pdf'] }}>
                    <FileField source="src" title="title" target="_blank" />
                </FileInput>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}